<button type="button" class="btn-reset ion-padding" (click)="selectVideo(b.video)">

  <img *ngIf="!b.image && b.video"[src]="videothumbpath(b.video)" alt="">

  <div *ngIf="b.image" class="smtileitem-wrapper"
    [ngStyle]="{'background-image': 'url(' + safeURL(mediaUrl(b.image)) + ')'}">
    <h2 class="title-button" expand="full" >
      <ion-icon name="play-circle-sharp"></ion-icon>
    </h2>
  </div>
</button>
